import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { UpdateTodoMutationVariables } from "@acto/gql/graphql";
import { useState, useCallback } from "react";

const UpdateTodoMutation = graphql(`
  mutation UpdateTodo($input: UpdateTodoInput!) {
    updateTodo(input: $input) {
      id
      title
      description
      dueDate
      processedStatus
      processedReason
      isNoteBased
      client {
        id
      }
      assignedUser {
        id
        name
        __typename
        employee {
          id
          name
          __typename
        }
      }
    }
  }
`);

export function useUpdateTodos() {
  const [result, updateTodo] = useMutation(UpdateTodoMutation);
  const [error, setError] = useState<Error | null>(null);

  const updateTodos = useCallback(
    async (variables: UpdateTodoMutationVariables) => {
      try {
        const response = await updateTodo(variables);
        if (response.error) {
          throw response.error;
        }
        return response.data?.updateTodo;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [updateTodo],
  );

  return { updateTodos, result, error };
}
